import baseURL from '../modules/api/url'
import { util } from '../util'
import { strings } from '../context/LanguageContext/strings'

export const productImport = {
    productImportSections: [
        'product_info',
        'product_photos',
        'product_categories',
        'product_prices',
        'product_equipment',
        'product_substitutions',
    ],

    productImportInitialState: {
        abv_liquor: undefined,
        action: 'update',
        age_restricted: false,
        brand: undefined,
        category: undefined,
        equipment: undefined,
        flavor_id: '1',
        handling: undefined,
        ignore_quantity: false,
        images: [],
        ipq: '1',
        limit_per_order: 100,
        localizations: {},
        long_desc: undefined,
        minimum_on_hand_quantity: undefined,
        multiplier: undefined,
        name: undefined,
        original_price: undefined,
        popularity: undefined,
        size_value: undefined,
        size: undefined,
        slin: '100000',
        subcategory: undefined,
        thumbnail: undefined,
        time_in_seconds: undefined,
        types: undefined,
        upc: undefined,
        product_substitutions: {
            is_active: true,
            product_ids: [],
        },
    },

    requiredFields: [
        'action',
        'slin',
        'ipq',
        'flavor_id',
        'age_restricted',
        'category',
        'limit_per_order',
        'long_desc',
        'name',
        'original_price',
        'upc',
        'ignore_quantity',
        'psa_code',
        'psa_desc',
        'category_code',
        'sub_category_code',
        'ldu',
        'min_order_qty',
        'max_order_qty',
    ],

    getProductImportsImagesFilters: () => [
        {
            placed_at: 'tableToolBar',
            type: 'string',
            key: 'id',
            display_name: strings.SECTION_MANAGE_PRODUCTS_IMPORTS_SEARCH_BY_PRODUCT_ID,
            display_value: '',
            post_value: '',
            defaultDisplayValue: '',
            defaultPostValue: '',
        },
    ],

    getProductsImportsImagesTableHeaders: () => [
        {
            id: 'image',
            label: strings.IMAGE,
            width: '25%',
        },
        {
            id: 'name',
            label: strings.SECTION_MANAGE_IMPORTS_TABLE_NAME,
            width: '50%',
        },
        {
            id: 'status',
            label: strings.STATUS,
            width: '25%',
        },
    ],

    imagesStatusIcons: {
        found: {
            found: util.CheckCircleIcon,
            color: 'success',
            pointer: false,
            size: 'xxs',
        },
        notfound: {
            notfound: util.CancelIcon,
            color: 'danger',
            pointer: false,
            size: 'xxs',
        },
    },

    productImportUrl: `${baseURL.SEVEN_NOW_CORE_API_URL}/catalog/products/productImport`,

    productImportUploadImagesUrl: `${baseURL.SEVEN_NOW_CORE_API_URL}/catalog/products/productImport/uploadimages`,

    productImportRefreshUrl: `${baseURL.SEVEN_NOW_CORE_API_URL}/catalog/products/productImport/refresh`,

    productsImportsImagesUrlPath: `${baseURL.SEVEN_NOW_CORE_API_URL}/catalog/products/productImport/getS3Images`,

    productUrl: `${baseURL.SEVEN_NOW_CORE_API_URL}/catalogadmin/assortments/catalog/products`,

    productsSearchUrl: `${baseURL.SEVEN_NOW_CORE_API_URL}/catalog/search/products`,

    productIdRegex: /^\d{6}-\d+-\d+-\d+-\d+$/,
}
